import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
gsap.registerPlugin(ScrollTrigger)

function sliderDotsAnimation (dots, currentSlide, nextSlide) {
    let totalDots = dots.find('.dot').length - 1

    dots.find('.right').removeClass('right')
    if (currentSlide < nextSlide) {
        if (totalDots === nextSlide && currentSlide === 0) {
            dots.find('.dot[data-slide="' + nextSlide + '"] .dot-animate').addClass('right')
        } else {
            dots.find('.dot[data-slide="' + currentSlide + '"] .dot-animate').addClass('right')
            dots.find('.dot[data-slide="' + nextSlide + '"] .dot-animate').removeClass('right')
        }
    } else {
        if (totalDots === currentSlide && nextSlide === 0) {
            dots.find('.dot[data-slide="' + currentSlide + '"] .dot-animate').addClass('right')
        } else {
            dots.find('.dot[data-slide="' + nextSlide + '"] .dot-animate').addClass('right')
            dots.find('.dot[data-slide="' + currentSlide + '"] .dot-animate').removeClass('right')
        }
    }

    dots.find('.active').addClass('in-active')
    dots.find('.active').removeClass('active')
    dots.find('.dot[data-slide="' + nextSlide + '"] .dot-animate').addClass('active')
    dots.find('.dot[data-slide="' + nextSlide + '"] .dot-animate').removeClass('in-active')
}

export { sliderDotsAnimation }
